import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Loader;
import { Loader } from "@crehana/ui";
import { useAvailableSurvey } from "../Survey/hooks";
import Loadable from "../../Loadable";
import { jsx as _jsx } from "react/jsx-runtime";
var LazySurveyReminder = function LazySurveyReminder(props) {
  var _useAvailableSurvey = useAvailableSurvey(),
    loading = _useAvailableSurvey.loading,
    hasAvailableSurveyToAnswer = _useAvailableSurvey.hasAvailableSurveyToAnswer,
    surveyToAnswerId = _useAvailableSurvey.surveyToAnswerId;
  return !loading && hasAvailableSurveyToAnswer && surveyToAnswerId ? /*#__PURE__*/_jsx(Loadable, _objectSpread({
    module: function module() {
      return import(/* webpackChunkName: "survey-reminder-loadable" */"./SurveyReminder");
    },
    Loader: _Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {}))
  }, props)) : null;
};
export default LazySurveyReminder;